export interface BatchInterface {
  /**
   * 批次名
   */
  name?: string
  /**
   * 名额
   */
  quota?: number
  /**
   * 本批次当前导入的待摇号用户人数
   */
  userCount?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Batch implements BatchInterface {
  /**
   * 批次名
   */
  name?: string
  /**
   * 名额
   */
  quota?: number
  /**
   * 本批次当前导入的待摇号用户人数
   */
  userCount?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: BatchInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      quota: _quota,
      userCount: _userCount,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.quota = _quota
    this.userCount = _userCount
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
